var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 14L10.5 21.5",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21.5L23.5 29L19.5227 32.5354C19.2088 32.8144 18.754 32.8675 18.3842 32.6684L7.18338 26.6372C6.59359 26.3196 6.47671 25.5233 6.95037 25.0496L10.5 21.5Z",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14L37 21.5",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 35.4224V29L29.0723 32.7139C28.7234 32.8883 28.305 32.844 28.0004 32.6003L23.5 29L19.5188 32.5388C19.2068 32.8162 18.7554 32.8705 18.3865 32.6752L10.5 28.5V35.4224C10.5 35.7798 10.6907 36.11 11.0003 36.2886L23.0003 43.2117C23.3095 43.3901 23.6905 43.3901 23.9997 43.2117L35.9997 36.2886C36.3093 36.11 36.5 35.7798 36.5 35.4224Z",
    fill: "#087E38",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37 21.5L24 29L27.9773 32.5354C28.2912 32.8144 28.746 32.8675 29.1158 32.6684L40.3166 26.6372C40.9064 26.3196 41.0233 25.5233 40.5496 25.0496L37 21.5Z",
    stroke: "#2A2E3C",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 29V43.5L11.0003 36.2886C10.6907 36.11 10.5 35.7798 10.5 35.4224V28.5",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26.5L14 21V11.5L24 6L34 11.5V21L24 26.5Z",
    fill: "#087E38",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9851 19.5901L22.8333 25.1141L23.5 25.5L23.668 17.8084L14.5013 12.5V14L22.4925 18.7007C22.8064 18.8853 22.9951 19.226 22.9851 19.5901Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.5L24 6L34 11.5L24 17.5L14 11.5Z",
    fill: "white",
    stroke: "#2A2E3C",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0586 17.6055V26.4994",
    stroke: "#2A2E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepack);
export default __webpack_public_path__ + "static/media/repack.fa95af10f75e139c454382080b5c9c4d.svg";
export { ForwardRef as ReactComponent };